import React, { useState } from 'react';
import { loginWithCode } from '../api';
import './Login.css';

interface LoginProps {
  onLogin: (userId: string, username: string, permissions?: string[]) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!code.trim()) {
      setError('Please enter an access code');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const user = await loginWithCode(code.trim());
      // Store user info in localStorage (accessCode is already stored by loginWithCode)
      localStorage.setItem('userId', user.id);
      localStorage.setItem('username', user.username);
      onLogin(user.id, user.username, user.permissions);
    } catch (err: any) {
      setError(err.response?.status === 401 ? 'Invalid access code' : 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Login</h1>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="code">Enter your access code</label>
            <input
              id="code"
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Enter your access code"
              disabled={loading}
              autoFocus
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" disabled={loading || !code.trim()}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;